<template>
  <div>
      <Header></Header>
      <div class="main"><router-view></router-view></div>
      <Returntop></Returntop>
      <Focus></Focus>
      <Footer></Footer>
  </div>
</template>

<script>
import Returntop from '@/components/Returntop'
import Focus from '@/components/Focus'
export default {
  components:{ Returntop,Focus },
  name: 'Index',
  data () {
    return {

    }
  },
  
}
</script>

<style scoped>
.main {
    padding-bottom: 8.125rem;
    background: #f7f7f7;
    height: auto;
}

.footer {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 300px;
    background: aqua;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue